import React, { useState } from 'react'
import ModalLD3 from '../Modal/ModalLD3';
import { Button, Spinner } from '@livingdesign/react';

export const QA_ID_PREFIX = "LD3-AlertModal";

function AlertModal({
    show,
    handleClose,
    title,
    message,
    cancelButtonText,
    confirmButtonText,
    handleConfirm,
}) {

    const [loading, setLoading] = useState(false);

    return (
        <>
        {show &&
            <ModalLD3
                data-testid={`${QA_ID_PREFIX}-modal`}
                isOpen={show}
                onClose={() => {
                    if(loading) return;
                    handleClose();
                }}
                title={title}
                size="medium"
                actions={(
                    <div data-testid={`${QA_ID_PREFIX}-actions`} style={{display: 'flex'}}>
                        <Button
                            variant='secondary'
                            data-testid={`${QA_ID_PREFIX}-cancel-button`}
                            UNSAFE_className="create-campaign-warn-modal-btn create-campaign-modal-cancel-btn"
                            onClick={() => {
                                if(loading) return;
                                handleClose();
                            }}
                            disabled={loading}
                        >
                            {cancelButtonText}
                        </Button>
                        <Button
                            variant='primary'
                            data-testid={`${QA_ID_PREFIX}-confirm-button`}
                            UNSAFE_className="create-campaign-warn-modal-yes-btn create-campaign-modal-submit-btn"
                            onClick={async (e) => {
                                setLoading(true);
                                await handleConfirm.call();
                                setLoading(false);
                                handleClose();
                            }}
                            disabled={loading}
                        >
                            {loading && <Spinner color="#2e2f32" size="small"/>}
                            {confirmButtonText}
                        </Button>
                    </div>
                )}
            >
                <div data-testid={`${QA_ID_PREFIX}-message`}>
                    {message}
                </div>
            </ModalLD3>
        }
        </>
    )
}

export default AlertModal;